module.exports = __webpack_public_path__ + "static/media/industrial.3825fd22.jpg";